<mat-expansion-panel *ngIf="grupoRegistros || formulario">
    <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
            {{titulo}}
            <mat-icon style="margin-left: 10px; color: var(--cf-brand-dark);">info</mat-icon>
        </mat-panel-title>

        <mat-panel-description class="panel-description" *ngIf="!formulario || (formulario && grupoRegistros)">
            <span>Total: {{grupoRegistros.totalTiempo}}</span>
            <div class="panel-actions">
                <button mat-stroked-button type="submit" (click)="validarTodosPendientes(); $event.stopPropagation()"
                    *ngIf="tieneRegistrosSinValidar()">
                    Validar todos los registros
                </button>
                <button mat-stroked-button type="submit" (click)="exportarExcel(); $event.stopPropagation()">
                    Exportar a Excel
                </button>
                <button mat-stroked-button type="submit" (click)="exportarPdf(); $event.stopPropagation()">
                    Exportar a PDF
                </button>
                <button mat-stroked-button type="submit" (click)="exportarCsv(); $event.stopPropagation()">
                    Exportar a CSV
                </button>
            </div>
        </mat-panel-description>
    </mat-expansion-panel-header>

    <!-- Formulario de rango de fechas -->
    <mat-card appearance="outlined" *ngIf="formulario" class="fecha-range-card">
        <mat-card-content>
            <p>
                <span>
                    Seleccione el rango de fechas para buscar los registros de tiempo asociados al empleado
                    seleccionado.
                </span>
            </p>
            <form [formGroup]="formRangoFechas" (ngSubmit)="buscarPorRango()">
                <div class="fecha-range-form">
                    <mat-form-field>
                        <mat-label>Fecha inicio</mat-label>
                        <input matInput [matDatepicker]="pickerInicio" formControlName="fechaInicio" [max]="maxDate">
                        <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                        <mat-datepicker #pickerInicio></mat-datepicker>
                        <mat-error *ngIf="formRangoFechas.get('fechaInicio').hasError('required')">
                            La fecha de inicio es requerida
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Fecha fin</mat-label>
                        <input matInput [matDatepicker]="pickerFin" formControlName="fechaFin" [max]="maxDate">
                        <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFin></mat-datepicker>
                        <mat-error *ngIf="formRangoFechas.get('fechaFin').hasError('required')">
                            La fecha fin es requerida
                        </mat-error>
                    </mat-form-field>

                    <button mat-raised-button color="primary" type="submit" [disabled]="!formRangoFechas.valid">
                        Buscar
                    </button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>

    <!-- Días -->
    <div *ngIf="!formulario || (formulario && grupoRegistros)">
        <ng-container *ngFor="let dia of grupoRegistros.dias; trackBy: trackByIndex">
            <mat-card appearance="outlined" class="day-card mb-3">
                <mat-card-header>
                    <mat-card-title>{{dia.fecha | date:'EEEE, d MMMM'}}</mat-card-title>
                    <mat-card-subtitle>Total: {{dia.totalDia}}</mat-card-subtitle>
                    <button mat-icon-button [matMenuTriggerFor]="diaMenu" class="dia-menu-button">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </mat-card-header>

                <mat-card-content>
                    <!-- Registros del día -->
                    <mat-list>
                        <mat-list-item *ngFor="let registro of dia.registros; trackBy: trackByIndex" class="registro-item">
                            <div class="registro-content">
                                <div class="tiempo-info">
                                    <span class="hora">
                                        {{registro.horaEntrada | date:'HH:mm'}} - {{registro.horaSalida | date:'HH:mm'}}
                                    </span>
                                    <!-- Icono de geolocalización -->
                                    <mat-icon *ngIf="tieneGeolocalizacion(registro)" class="geolocalizacion-icon"
                                        matTooltip="Ver ubicación en el mapa" style="color: var(--cf-brand-dark) !important;"
                                        (click)="mostrarMapa(registro); $event.stopPropagation()">
                                        place
                                    </mat-icon>
                                </div>

                                <div class="estado-info">
                                    <mat-chip-listbox>
                                        <mat-chip-option [color]="registro.estado === 2 ? 'primary' : 'warn'" selected>
                                            {{registro.cadenaEstado}}
                                        </mat-chip-option>
                                        <mat-chip-option *ngIf="registro.finalizadoAutomatico" color="accent" selected>
                                            Auto
                                        </mat-chip-option>
                                    </mat-chip-listbox>
                                </div>

                                <!-- Pausas -->
                                <div class="pausas-container" *ngIf="registro.pausas?.length">
                                    <mat-expansion-panel class="pausa-panel">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                Pausas ({{registro.pausas.length}})
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>

                                        <mat-list>
                                            <mat-list-item *ngFor="let pausa of registro.pausas; trackBy: trackByIndex">
                                                <div class="pausa-info">
                                                    <span class="pausa-duracion">{{pausa.fechaInicio | date:'HH:mm'}} -
                                                        {{pausa.fechaFin | date:'HH:mm'}}</span>
                                                    <span class="pausa-minutos">({{ redonderoBancario(pausa.duracionMinutos) }} min.)</span>
                                                    <span class="pausa-motivo"
                                                        *ngIf="pausa.motivo">{{pausa.motivo}}</span>
                                                </div>
                                            </mat-list-item>
                                        </mat-list>
                                    </mat-expansion-panel>
                                </div>
                            </div>

                            <button mat-icon-button [matMenuTriggerFor]="registroMenu"
                                [matMenuTriggerData]="{registro: registro}" class="registro-menu-button">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                        </mat-list-item>
                    </mat-list>
                </mat-card-content>
            </mat-card>
        </ng-container>
    </div>
</mat-expansion-panel>

<!-- Menú de acciones para día -->
<mat-menu #diaMenu="matMenu">
    <button mat-menu-item (click)="validarTodosPendientes()">
        <mat-icon>check_circle</mat-icon>
        <span>Validar todos los pendientes</span>
    </button>
</mat-menu>


<!-- Menú de acciones para registro individual -->
<mat-menu #registroMenu="matMenu">
    <ng-template matMenuContent let-registro="registro">
        <button mat-menu-item (click)="validarRegistro(registro)" *ngIf="registro.estado === 8">
            <mat-icon>check_circle</mat-icon>
            <span>Validar</span>
        </button>
        <button mat-menu-item (click)="rechazarRegistro(registro)" *ngIf="registro.estado === 8">
            <mat-icon>cancel</mat-icon>
            <span>Rechazar</span>
        </button>
        <button mat-menu-item (click)="editarRegistro(registro)">
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
        </button>
        <button mat-menu-item (click)="verHistorial(registro)">
            <mat-icon>history</mat-icon>
            <span>Ver historial</span>
        </button>
        <button mat-menu-item (click)="mostrarMapa(registro)" *ngIf="tieneGeolocalizacion(registro)">
            <mat-icon>location_on</mat-icon>
            <span>Ver ubicación</span>
        </button>
    </ng-template>
</mat-menu>
